import axios from 'axios'
import { Row } from './convertPendingSchedules'

async function fetchPendingSchedules(headers: any, factory_id: number): Promise<Row[]> {
  return axios.get(`/v0/factories/${factory_id}/calendar-pending-processes`, {
    headers: headers
  })
    .then((res) => res.data)
    .catch((reason) => {
      throw reason
    })
}

export default fetchPendingSchedules
